import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { Moment} from 'moment';

const moment =  _moment;
const MY_FORMATS = {
  parse: {
    dateInput: 'MMM YYYY',
  },
  display: {
    dateInput: 'MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-month-year-picker',
  templateUrl: './month-year-picker.html',
  styleUrl: './month-year-picker.scss',
  standalone:false,
   providers: [
    provideMomentDateAdapter(MY_FORMATS),
  ],
})
export class MonthYearPicker implements OnInit{
  @Output() monthChange = new EventEmitter();
  @Input() set minDate (minDate) {
    this.minimumDate = moment.utc(minDate).startOf('month');
    this.dateControl.setValue(moment.utc(this.currentDate));
  }
  minimumDate: any;
  dateControl = new FormControl();
  currentDate = new Date();

  constructor(){ 
  }

  ngOnInit(): void {
    this.dateControl.setValue(moment.utc(this.currentDate));
  }

  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
    const dayview = document.querySelector(".mat-datepicker-content") as HTMLElement;
    if (dayview) {
      dayview.style.display = "none";
    }
    const selectedDate = this.dateControl.value ?? moment.utc();
    selectedDate.date(1);
    selectedDate.month(normalizedMonthAndYear.month());
    selectedDate.year(normalizedMonthAndYear.year());
    this.dateControl.setValue(selectedDate);
    datepicker.close();
    this.monthChange.emit(normalizedMonthAndYear);
  }
  
}
